<template>
  <div :ref="ename" class="ec"></div>
</template>
    
    <script>
import * as echarts from "echarts";
import { fontSize } from "@/js/utils";

var placeHolderStyle = {
  normal: {
    label: {
      show: false,
    },
    labelLine: {
      show: false,
    },
    color: "rgba(0,0,0,0)",
    borderWidth: 0,
  },
  emphasis: {
    color: "rgba(0,0,0,0)",
    borderWidth: 0,
  },
};

var dataStyle = {
  normal: {
    show: false,
  },
};
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    ename: {
      type: String,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    onclick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myChart: "",
      list: [],
      option: {
        grid: { top: "10%", right: "10%", bottom: "10%", left: "15%" },
        tooltip: { trigger: "axis" },
        xAxis: {
          boundaryGap: false,
          axisLabel: {
            textStyle: {
              color: "#fff",
              fontSize: fontSize(0.11),
            },
          },
          axisLine: {
            lineStyle: {
              color: "#4FA6FF60",
            },
          },
          data: [],
        },
        yAxis: [
          {
            type: "value",
            name: "",
            splitLine: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: fontSize(0.11),
              },
            },
          },
        ],
        series: [
          {
            name: "",
            type: "line",
            symbolSize: 6,
            symbol: "none",
            smooth: true,
            data: [],
            zlevel: 3,
            label: {
              show: false,
              position: "top",
              textStyle: {
                color: "#fff",
                fontSize: fontSize(0.12),
              },
            },
            itemStyle: {
              normal: {
                color: "#3A84FF",
                lineStyle: {
                  color: "#3A84FF",
                  width: 2,
                },
                areaStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 1,
                    x2: 0,
                    y2: 0,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(0, 0, 0, 0)", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#1fb5fc", // 100% 处的颜色
                      },
                    ],
                  },
                },
              },
            },
          },
        ],
      },
    };
  },
  computed: {
    full() {
      return this.$store.state.menuShow;
    },
  },
  watch: {
    full(newval) {
      this.myChart.resize();
    },
    data: {
      handler(newVal) {
        if (newVal && this.myChart != "") {
          this.list = newVal;
          this.updateOption();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getEchartData();
    window.addEventListener("resize", this.myChart.resize);
  },
  beforeDestroy() {
    // 移除窗口改变监听
    this.onclick && this.myChart.off("click", this.getClickInfo);
    window.removeEventListener("resize", this.myChart.resize);
  },
  methods: {
    getClickInfo(e) {
      this.$emit("click", e);
    },
    updateOption() {
      this.handlerData();
      this.myChart.setOption(this.option);
    },
    handlerData() {
      this.option.xAxis.data = this.data.xData || [];
      this.option.series[0].data = this.data.yData || [];
    },
    getEchartData() {
      this.handlerData();
      const chart = this.$refs[this.ename];
      if (chart) {
        this.myChart = this.$echarts.init(chart);
        this.myChart.setOption(this.option);
        this.onclick && this.myChart.on("click", this.getClickInfo);
      }
    },
  },
};
</script>
    
    <style lang="less" scoped>
.ec {
  width: 100%;
  height: 100%;
}
</style>